import styled from "styled-components";
import ContainerVotacao from "../Modulos/Cipa/ContainerVotacao";
import { VotacaoProvider } from "../contexts/VotacaoContext";

const Corpo = styled.div`
    width: 100%;
    height: 100dvh;
    background-color: #263b4b;
    display: flex;
`

const CipaVotacao = () => {
    return(
        <VotacaoProvider>
            <Corpo>
                <ContainerVotacao />
            </Corpo>
        </VotacaoProvider>
    )
}

export default CipaVotacao;